var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-as-user"},[_c('a',{staticClass:"login-as-user__link",on:{"click":function($event){return _vm.loginWithAnotherAccount()}}},[_vm._v("LOGIN WITH THIS ACCOUNT")])])}
var staticRenderFns = []

export { render, staticRenderFns }